import React from "react";
import { Reveal, Stagger, StaggerItem } from "@/components/motion/Reveal";
import { STOCK, ASSETS } from "@/data/content";
import { useI18n } from "@/i18n";

export default function Surroundings() {
  const { t } = useI18n();
  const sur = t.surroundings;
  const SURROUNDINGS = sur.items;
  return (
    <section
      id="okolica"
      data-testid="surroundings-section"
      className="relative bg-canvas-surface py-14 md:py-20"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-12 gap-8 md:gap-16 items-end mb-16 md:mb-24">
          <div className="col-span-12 md:col-span-6">
            <Reveal>
              <p className="overline mb-6">{sur.overline}</p>
              <h2 className="serif text-4xl md:text-5xl lg:text-6xl font-light leading-[1.05] tracking-tight text-ink">
                {sur.headingA} <br />
                <span className="italic">{sur.headingB}</span>
              </h2>
            </Reveal>
          </div>
          <div className="col-span-12 md:col-span-5 md:col-start-8">
            <Reveal delay={0.15}>
              <p className="text-ink-muted text-base md:text-lg leading-relaxed">
                {sur.intro}
              </p>
            </Reveal>
          </div>
        </div>

        {/* Wide image */}
        <Reveal>
          <div className="aspect-[16/9] overflow-hidden mb-16 md:mb-24">
            <img
              src={ASSETS.surrRiver}
              alt={sur.riverAlt}
              className="w-full h-full object-cover"
              style={{ objectPosition: "center 28%" }}
            />
          </div>
        </Reveal>

        {/* Grid of surroundings */}
        <Stagger className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-x-10 gap-y-12">
          {SURROUNDINGS.map((s, i) => (
            <StaggerItem key={s.title}>
              <div className="flex items-baseline gap-3 mb-3">
                <span className="text-brand-red text-xs tracking-[0.3em]">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <span className="h-px flex-1 bg-ink/20" />
                <span className="text-ink-muted text-xs tracking-[0.15em] uppercase">
                  {s.km}
                </span>
              </div>
              <h3 className="serif text-2xl md:text-[1.6rem] font-light text-ink leading-tight">
                {s.title}
              </h3>
              <p className="mt-3 text-ink-muted text-sm leading-relaxed">
                {s.desc}
              </p>
            </StaggerItem>
          ))}
        </Stagger>

        {/* Pair of bottom images */}
        <div className="mt-20 grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
          <Reveal>
            <div className="aspect-[4/3] overflow-hidden">
              <img
                src={ASSETS.surrAerial}
                alt={sur.aerialAlt}
                className="w-full h-full object-cover"
              />
            </div>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="aspect-[4/3] overflow-hidden">
              <img
                src={ASSETS.surrBank}
                alt={sur.bankAlt}
                className="w-full h-full object-cover"
              />
            </div>
          </Reveal>
        </div>

        {/* Second pair — polne drogi i pola rzepaku */}
        <div className="mt-4 md:mt-6 grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
          <Reveal>
            <div className="aspect-[4/3] overflow-hidden">
              <img
                src={ASSETS.surrPath}
                alt={sur.pathAlt}
                className="w-full h-full object-cover"
              />
            </div>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="aspect-[4/3] overflow-hidden">
              <img
                src={ASSETS.surrFields}
                alt={sur.fieldsAlt}
                className="w-full h-full object-cover"
              />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
